import "./styles/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import StorySection from "./components/StorySection";
import SubscriptionSection from "./components/SubscriptionSection";
import MenuSection from "./components/MenuSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WaveDivider from "./components/WaveDivider";
import { COLORS } from "./constants";

function App() {
  return (
    <div className="site-shell">
      <Header />

      <main>
        <Hero />
        <AboutSection />
        <WaveDivider bg={COLORS.white} fill={COLORS.red} />
        <StorySection />
        <WaveDivider bg={COLORS.red} fill={COLORS.orange} />
        <SubscriptionSection />
        <WaveDivider bg={COLORS.orange} fill={COLORS.white} />
        <MenuSection />
        <WaveDivider bg={COLORS.white} fill={COLORS.red} />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}

export default App;
